export const ExclamationCircleSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
      <path
        fill="currentColor"
        d="M7 3.6667a.6666.6666 0 0 0-.6666.6666V7a.6666.6666 0 1 0 1.3333 0V4.3333A.6667.6667 0 0 0 7 3.6667Zm.6133 5.7466a.5072.5072 0 0 0-.06-.12l-.08-.1a.6667.6667 0 0 0-.7266-.14.7668.7668 0 0 0-.22.14.6667.6667 0 0 0-.1933.4734.6666.6666 0 0 0 .0533.2533.6002.6002 0 0 0 .36.36.6262.6262 0 0 0 .5067 0 .5995.5995 0 0 0 .36-.36.6666.6666 0 0 0 .0533-.2533.9074.9074 0 0 0 0-.1334.4269.4269 0 0 0-.0534-.12ZM7 .3333a6.6667 6.6667 0 1 0 0 13.3333A6.6667 6.6667 0 0 0 7 .3333Zm0 12A5.3336 5.3336 0 0 1 2.0727 9.041 5.3333 5.3333 0 1 1 7 12.3333Z"
      />
    </svg>
  );
};
